import { Spinner } from 'react-bootstrap'
import { useParams } from 'react-router-dom'

import { useIsFetching } from '@tanstack/react-query'
import styled from 'styled-components'
import { StringParam, useQueryParam } from 'use-query-params'

import { Colours } from '@lib/theme'

import { DrilldownHeader } from './DrilldownHeader'
import { DrilldownTable } from './DrilldownTable'
import { RecordModal } from './RecordModal'

export function Drilldown() {
  const [previewId, setPreviewId] = useQueryParam('preview', StringParam)
  const previewRecordId = previewId ? previewId : false

  const numberFetching = useIsFetching()

  const { id, subAsset } = useParams<{ id: string; subAsset: string }>()
  if (!id || !subAsset) {
    return null
  }

  return (
    <Container>
      <Header>
        <DrilldownHeader dataPackageId={id} subAssetId={subAsset} />

        <StyledSpinner animation="border" $loading={numberFetching > 0} />
      </Header>

      <TableContainer>
        <DrilldownTable
          dataPackageId={id}
          subAssetId={subAsset}
          onRowPreview={(record) =>
            setPreviewId(record.recordName, 'replaceIn')
          }
        />
      </TableContainer>

      <RecordModal
        dataPackageId={id}
        recordId={previewRecordId}
        onClosed={() => setPreviewId(null, 'replaceIn')}
      />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  align-items: stretch;

  height: 100%;
  width: 100%;

  background-color: ${Colours.BgShade.Mid};
`

const TableContainer = styled.div`
  flex: 1 1 auto;
  overflow: scroll;

  background-color: ${Colours.BgShade.Light};
`

const Header = styled.header`
  padding: 0.5rem;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const StyledSpinner = styled(Spinner)`
  width: 1.2rem;
  height: 1.2rem;
  opacity: ${({ $loading }) => ($loading ? 1 : 0)};
  color: ${Colours.Brand.BlueMid};

  transition: opacity ease-in-out 300ms;
`
